export let places = [
  {
    id: "1",
    name: "שפע יששכר",
    address: "יבנה הקישון 6",
  },
  {
    id: "2",
    name: "אושר עד",
    address: "Modiin-Maccabim-Reut תלתן 1",
    subRows: [
      {
        id: "2-1",
        name: "אושר עד - סניף 1",
        address: "Modiin-Maccabim-Reut רחוב דוגמה 1",
        subRows: [
          {
            id: "2-1-1",
            name: "אושר עד - מחסן",
            address: "Modiin-Maccabim-Reut אזור תעשיה",
          },
        ],
      },
      {
        id: "2-2",
        name: "אושר עד - סניף 2",
        address: "Modiin-Maccabim-Reut רחוב דוגמה 2",
      },
    ],
  },
  {
    id: "3",
    name: "שפע יששכר 2",
    address: "תל אביב פלורנטין",
    subRows: [
      {
        id: "3-1",
        name: "שפע יששכר 2 - סניף 1",
        address: "תל אביב דיזנגוף",
      },
    ],
  },
];

export let organizations = [
  {
    organizationId: "1",
    organizationName: "רמי לוי",
    organizationAddress: "יבנה הקישון 5",
    subRows: [
      {
        organizationId: "1-1",
        organizationName: "רמי לוי - סניף 1",
        organizationAddress: "ראשון לציון",
        subRows: [
          {
            organizationId: "1-1-1",
            organizationName: "רמי לוי - מחסן",
            organizationAddress: "אזור תעשייה ראשון",
          },
        ],
      },
    ],
  },
  {
    organizationId: "2",
    organizationName: "אושר עד",
    organizationAddress: "מודיעין מכבים רעות תלתן 1",
    subRows: [
      {
        organizationId: "2-1",
        organizationName: "אושר עד - סניף 1",
        organizationAddress: "מודיעין מכבים רעות רחוב דוגמה 1",
      },
      {
        organizationId: "2-2",
        organizationName: "אושר עד - סניף 2",
        organizationAddress: "מודיעין מכבים רעות רחוב דוגמה 2",
      },
    ],
  },
];

export const devices = [
  {
    serialNumber: "4G200200390",
    model: "SG304GB",
    name: "בקר אתחול ופתיחה - יוקלר ראשי",
    address: "חטיבה תשע 1, עפולה, Israel",
    status: "Connected",
    health: {
      connectionStability: 50,
      signalQuality: 40,
      voltageStability: 100,
      signalNoise: 25,
    },
    subRows: [
      {
        serialNumber: "4G210200391",
        model: "SG304GB",
        name: "camera",
        address: "שדרות בן גוריון 12, תל אביב, Israel",
        status: "Disconnected",
        health: {
          connectionStability: 30,
          signalQuality: 20,
          voltageStability: 30,
          signalNoise: 30,
        },
      },
      {
        serialNumber: "4G220200392",
        model: "SG304GB",
        name: "nayax",
        address: "דרך השלום 44, חיפה, Israel",
        status: "Connected",
        health: {
          connectionStability: 90,
          signalQuality: 85,
          voltageStability: 95,
          signalNoise: 10,
        },
      },
      {
        serialNumber: "4G230200392",
        model: "SG304GB",
        name: "barcode scanner",
        address: "דרך השלום 44, חיפה, Israel",
        status: "Connected",
        health: {
          connectionStability: 90,
          signalQuality: 85,
          voltageStability: 95,
          signalNoise: 10,
        },
      },
      {
        serialNumber: "4G230200392",
        model: "SG304GB",
        name: "intercom",
        address: "דרך השלום 44, חיפה, Israel",
        status: "Connected",
        health: {
          connectionStability: 90,
          signalQuality: 85,
          voltageStability: 95,
          signalNoise: 10,
        },
      },
      {
        serialNumber: "4G230200392",
        model: "SG304GB",
        name: "barrier",
        address: "דרך השלום 44, חיפה, Israel",
        status: "Connected",
        health: {
          connectionStability: 90,
          signalQuality: 85,
          voltageStability: 95,
          signalNoise: 10,
        },
      },
      {
        serialNumber: "4G230200392",
        model: "SG304GB",
        name: "display",
        address: "דרך השלום 44, חיפה, Israel",
        status: "Connected",
        health: {
          connectionStability: 90,
          signalQuality: 85,
          voltageStability: 95,
          signalNoise: 10,
        },
      },
  ]
  },
  {
    serialNumber: "4G200200391",
    model: "SG304GB",
    name: "בקר גיבוי - יוקלר משני",
    address: "שדרות בן גוריון 12, תל אביב, Israel",
    status: "Disconnected",
    health: {
      connectionStability: 30,
      signalQuality: 20,
      voltageStability: 30,
      signalNoise: 30,
    },
  },
  {
    serialNumber: "4G200200392",
    model: "SG304GB",
    name: "חיישן טמפרטורה - תחנה מרכזית",
    address: "דרך השלום 44, חיפה, Israel",
    status: "Connected",
    health: {
      connectionStability: 90,
      signalQuality: 85,
      voltageStability: 95,
      signalNoise: 10,
    },
  },
];


export let organizationUsers = [
  {
    email: "user1@example.com",
    name: "John Doe",
    status: "Active",
    organization: "רמי לוי",
  },
  {
    email: "user2@example.com",
    name: "Jane Smith",
    status: "Inactive",
    organization: "אושר עד",
  },
];
